import React from "react";
import { Link } from "react-router-dom";
import { CS_TEL_HREF, CS_SMS_HREF, CS_LABEL, AUTO_LABEL } from "@/brand";
import { Fireflies } from "@/components/effects/Fireflies";
import { T } from "@/context/SiteContent";

export const Footer = () => (
  <footer className="relative pt-20 pb-10 border-t border-[#FFD166]/12" style={{ background: "linear-gradient(180deg, rgba(4,10,15,0.85) 0%, rgba(2,6,9,0.95) 100%)" }}>
    <Fireflies count={12} />
    <div className="container relative z-10 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-1">
        <div className="font-serif text-3xl mb-2" style={{ background: "linear-gradient(135deg,#F4A93A,#FFD166,#D97B37)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
          Enchanted
        </div>
        <div className="eyebrow">Gear Rentals</div>
        <p className="mt-4 text-[#B9C8D5] text-sm max-w-xs">
          <T k="footer.tagline" fallback="Family-owned baby gear rentals near Walt Disney World — delivered free to your resort, hotel or vacation home." />
        </p>
        <p className="mt-2 text-[10px] text-[#B9C8D5]/60">Formerly Enchanted Baby Gear Rentals</p>
      </div>

      {/* Strollers column */}
      <div>
        <div className="eyebrow mb-4">Strollers</div>
        <ul className="space-y-2 text-sm text-[#F6F1E4]/85">
          <li><Link to="/strollers" className="hover:text-[#FFD166]">All Strollers</Link></li>
          <li><Link to="/disney-world-stroller-rentals" className="hover:text-[#FFD166]">Disney World Strollers</Link></li>
          <li><Link to="/stroller-rentals-orlando" className="hover:text-[#FFD166]">Orlando Strollers</Link></li>
          <li><Link to="/double-stroller-rentals-orlando" className="hover:text-[#FFD166]">Double Strollers</Link></li>
          <li><Link to="/single-stroller-rentals-orlando" className="hover:text-[#FFD166]">Single Strollers</Link></li>
          <li><Link to="/universal-orlando-stroller-rentals" className="hover:text-[#FFD166]">Universal Orlando</Link></li>
        </ul>
      </div>

      {/* Delivery + info column */}
      <div>
        <div className="eyebrow mb-4">Delivery &amp; Info</div>
        <ul className="space-y-2 text-sm text-[#F6F1E4]/85">
          <li><Link to="/delivery" className="hover:text-[#FFD166]">Delivery Areas</Link></li>
          <li><Link to="/delivery/walt-disney-world-resorts" className="hover:text-[#FFD166]">Walt Disney World</Link></li>
          <li><Link to="/delivery/universal-orlando" className="hover:text-[#FFD166]">Universal Orlando</Link></li>
          <li><Link to="/delivery/vacation-homes" className="hover:text-[#FFD166]">Vacation Homes</Link></li>
          <li><Link to="/deals" className="hover:text-[#FFD166]">Deals</Link></li>
          <li><a href="#catalog" className="hover:text-[#FFD166]">Baby Gear</a></li>
        </ul>
      </div>

      {/* Company + contact column */}
      <div>
        <div className="eyebrow mb-4">Contact</div>
        <ul className="space-y-2 text-sm text-[#F6F1E4]/85">
          <li><Link to="/about" className="hover:text-[#FFD166]">About Us</Link></li>
          <li><Link to="/faq" className="hover:text-[#FFD166]">FAQ</Link></li>
          <li><Link to="/contact" className="hover:text-[#FFD166]">Contact</Link></li>
          <li><a href="tel:+16893457368" className="hover:text-[#FFD166]">689-345-RENT (7368)</a></li>
          <li><a href="mailto:info@enchantedgearrentals.com" className="hover:text-[#FFD166]"><T k="footer.email" fallback="info@enchantedgearrentals.com" /></a></li>
          <li data-testid="footer-cs-phone"><a href={CS_TEL_HREF} className="hover:text-[#FFD166]"><T k="footer.phone" fallback={CS_LABEL} /></a> · <a href={CS_SMS_HREF} className="hover:text-[#FFD166]" data-testid="footer-text-us">Text us</a></li>
          <li className="text-xs text-[#B9C8D5]" data-testid="footer-auto-phone">{AUTO_LABEL}</li>
        </ul>
      </div>
    </div>

    {/* HTML Sitemap */}
    <div className="container relative z-10 mt-12 pt-8 border-t border-[#FFD166]/8">
      <div className="eyebrow mb-4 text-[10px]">Site map</div>
      <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-[#B9C8D5]/70">
        <Link to="/" className="hover:text-[#FFD166]">Home</Link>
        <Link to="/strollers" className="hover:text-[#FFD166]">Strollers</Link>
        <Link to="/disney-world-stroller-rentals" className="hover:text-[#FFD166]">Disney World Stroller Rentals</Link>
        <Link to="/stroller-rentals-orlando" className="hover:text-[#FFD166]">Orlando Stroller Rentals</Link>
        <Link to="/double-stroller-rentals-orlando" className="hover:text-[#FFD166]">Double Strollers</Link>
        <Link to="/single-stroller-rentals-orlando" className="hover:text-[#FFD166]">Single Strollers</Link>
        <Link to="/universal-orlando-stroller-rentals" className="hover:text-[#FFD166]">Universal Orlando Strollers</Link>
        <Link to="/delivery" className="hover:text-[#FFD166]">Delivery Areas</Link>
        <Link to="/delivery/walt-disney-world-resorts" className="hover:text-[#FFD166]">Disney Resort Delivery</Link>
        <Link to="/delivery/universal-orlando" className="hover:text-[#FFD166]">Universal Delivery</Link>
        <Link to="/delivery/vacation-homes" className="hover:text-[#FFD166]">Vacation Home Delivery</Link>
        <Link to="/about" className="hover:text-[#FFD166]">About Us</Link>
        <Link to="/faq" className="hover:text-[#FFD166]">FAQ</Link>
        <Link to="/contact" className="hover:text-[#FFD166]">Contact</Link>
        <Link to="/deals" className="hover:text-[#FFD166]">Deals</Link>
        <Link to="/stroller-quiz" className="hover:text-[#FFD166]">Stroller Quiz</Link>
        <Link to="/partners" className="hover:text-[#FFD166]">Partner Program</Link>
      </div>
    </div>

    <div className="container mt-8 pt-6 border-t border-[#FFD166]/10 flex flex-wrap justify-between gap-3 text-xs text-[#B9C8D5]">
      <div><T k="footer.copyright" fallback="© 2026 Enchanted Gear Rentals LLC · Not affiliated with The Walt Disney Company" /></div>
      <div className="flex items-center gap-4">
        <Link to="/privacy" className="hover:text-[#FFD166]" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-[#FFD166]" data-testid="footer-terms-link">Terms of Service</Link>
        <Link to="/partners" className="hover:text-[#FFD166]" data-testid="footer-partners-link">Partner Program</Link>
        <span className="opacity-50">·</span>
        <span><T k="footer.made_with" fallback="Handcrafted in the bayou" /></span>
      </div>
    </div>
  </footer>
);
